import * as React from 'react';
import Image from 'next/image';

import { cn } from '@blockworks/ui/utils';

type TopPriceInfoHeaderProps = {
    title: string;
    code: string;
    imageUrl: string | null;
    className?: string;
};

const TopPriceInfoHeader = (props: TopPriceInfoHeaderProps) => {
    const { title, code, imageUrl, className } = props;
    const [imageError, setImageError] = React.useState(false);

    const lowerCasedCode = code ? code.toLowerCase() : '';
    const fallbackImage = `/images/tokens/${lowerCasedCode}.svg`;
    const imageSrc = imageUrl && !imageError ? imageUrl : fallbackImage;

    return (
        <div className={cn('flex flex-wrap lg:flex-nowrap items-center text-left', className)}>
            <div className="item align-middle h-8 w-8 relative flex-shrink-0 sm:h-12 sm:w-12 md:h-14 md:w-14">
                <Image
                    alt={lowerCasedCode}
                    key={lowerCasedCode}
                    className="rounded-full border-white border-8 bg-white object-cover"
                    src={imageSrc}
                    fill
                    loading="lazy"
                    onError={() => setImageError(true)}
                    placeholder="empty"
                    itemProp="logo"
                />
            </div>
            <h1>
                <span className="text-dark ml-3 font-headline" itemProp="name">
                    {title}
                </span>
                <span className="ml-4 text-brand text-lg md:text-5xl" itemProp="alternateName">
                    {code.toUpperCase()}
                </span>
            </h1>
        </div>
    );
};

export default TopPriceInfoHeader;
